import React, { useState } from "react";
import Footer from "../components/Footer";
import Footprint from "../components/landing-page/Footprint";
import HeroSection from "../components/landing-page/HeroSection";
import HowItWorks from "../components/landing-page/HowItWorks";
import OngoingProjects from "../components/landing-page/OngoingProjects";
import Testimonials from "../components/landing-page/Testomonials";
import WaitlistPopup from "../components/modals/WaitlistPopup";

export default function LandingPage() {
  const [showWaitlistPopup, setShowWaitlistPopup] = useState(false);

  return (
    <>
      <HeroSection />
      <Footprint />
      <OngoingProjects />
      <HowItWorks onGetStarted={() => setShowWaitlistPopup(true)} />
      <div style={{ display: 'none' }}>
        <Testimonials />
      </div>
      
      <WaitlistPopup 
        isOpen={showWaitlistPopup}
        onClose={() => setShowWaitlistPopup(false)}
      />
    </>
  );
}
